import { createStore } from 'vuex'
import {getToken } from '@/utils/auth'
import {getUserInfo,Loginout,getConvention,getMyAmount,getMyDistributor,getBannerPage} from '@/api'



export const store = createStore({
  state: {
    isConnect:false,
    Token:'',
    chain:'',
    address:"",
    member:'',
    wordType:1,
    CountSet:{
      findCount:0,//点击次数
      isOpen:false  //是否开启分销
    },
    MyAmount:{
		  withdrawalAmount:0,
			depositAmount:0,
			interestAmount:0,
			actualAmount:0,
			teamCount:0,
	  },
    bankInfo:'',
    banner:[]

  },
  mutations: {
     set_banner:(state, data)=>{
      state.banner = data
    },
    set_Connect:(state, data)=>{
      state.isConnect = data
    },
    set_Token:(state, data)=>{
      state.Token = data
    },
    set_Chain:(state, data)=>{
      state.chain = data
    },
    set_address:(state, data)=>{
      state.address = data
    },
    set_member:(state, data)=>{
      state.member = data
    },
    set_wordType:(state, data)=>{
      state.wordType = data
    },
    set_CountSet:(state, data)=>{
      state.CountSet = data
    },
    set_MyAmount:(state, data)=>{
      state.MyAmount = data
    },
    set_bankInfo:(state, data)=>{
      state.bankInfo = data
    },
  },
  actions:{
    
    getClear({ commit }){

      commit('set_member','')
    },
    getReset({ commit }){
      Loginout().then(res=>{})
 
    },
    
    getMemberView({ commit }){
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
            const data = response.data
            commit('set_member', data)
            if(data.wordType==2){
              commit('set_wordType',2)
            }
            resolve(data)
          }).catch(error => {
            reject(error)
          })
      })
    } ,
    togetBannerPage({ commit }){
      return new Promise((resolve, reject) => {
        getBannerPage({
          pageNo:1,
          pageSize:100
        }).then(response => {
            const data = response.data
            commit('set_banner', data.list)
            resolve(data)
          }).catch(error => {
            reject(error)
          })
      })
    } ,
    togetConvention({ commit }){
      return new Promise((resolve, reject) => {
        getConvention().then(response => {
            const data = response.data
            commit('set_CountSet', data)
            resolve(data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    togetMyAmount({ commit }){
      return new Promise((resolve, reject) => {
        getMyAmount().then(response => {
            const data = response.data
            commit('set_MyAmount', data)
            resolve(data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    togetMyDistributor({ commit }){
      return new Promise((resolve, reject) => {
        getMyDistributor().then(response => {
            const data = response.data
            commit('set_bankInfo', data)
            resolve(data)
          }).catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {},
})
